
define('ldsh!modules/start/products/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div id="product-base-list"></div>\n';

}
return __p
};});

